import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { terminyMS, terminyMSByMonth } from '../data/terminy';
import { Calendar, Clock, Users } from 'lucide-react';

export default function TerminyOnlinePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main>
        {/* Hero */}
        <section className="relative pt-32 pb-20 bg-gradient-to-b from-slate-50 to-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center max-w-3xl mx-auto mb-16">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-50 border border-teal-100 rounded-full text-teal-700 text-sm font-medium mb-6">
                <Calendar className="w-4 h-4" />
                <span>Online kurzy pro jednotlivce i školy</span>
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
                Termíny online školení 2026
              </h1>
              <p className="text-lg text-slate-600 leading-relaxed">
                Vyberte si termín, který vám vyhovuje. Kurz probíhá ve 2 lekcích (celkem 8 vyučovacích hodin).
              </p>
            </div>

            <div className="max-w-6xl mx-auto mb-12">
              <div className="grid md:grid-cols-3 gap-6 text-center">
                <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200">
                  <Clock className="w-8 h-8 text-teal-600 mx-auto mb-3" />
                  <p className="text-sm text-slate-500 mb-1">Rozsah</p>
                  <p className="font-semibold text-slate-900">8 vyučovacích hodin</p>
                  <p className="text-xs text-slate-500">(2×4 hodiny)</p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200">
                  <Users className="w-8 h-8 text-teal-600 mx-auto mb-3" />
                  <p className="text-sm text-slate-500 mb-1">Pro koho</p>
                  <p className="font-semibold text-slate-900">Pedagogy MŠ, ZŠ, SŠ</p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200">
                  <Calendar className="w-8 h-8 text-teal-600 mx-auto mb-3" />
                  <p className="text-sm text-slate-500 mb-1">Dostupnost</p>
                  <p className="font-semibold text-slate-900">Ranní i odpolední</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Termíny MŠ/ZŠ */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
                Dostupné online termíny
              </h2>
              <p className="text-lg text-slate-600">
                Termíny jsou společné pro všechny typy škol. Obsah kurzu přizpůsobujeme podle účastníků.
              </p>
            </div>

            {/* Termíny po měsících */}
            <div className="space-y-12">
              {Object.entries(terminyMSByMonth).map(([month, terminy]) => (
                <div key={month}>
                  <h3 className="text-xl font-bold text-slate-900 mb-4">
                    {month}
                  </h3>
                  
                  <div className="overflow-x-auto">
                    <table className="w-full border-collapse">
                      <thead>
                        <tr className="bg-slate-50">
                          <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 border-b">#</th>
                          <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 border-b">Lekce 1</th>
                          <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 border-b">Lekce 2</th>
                          <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 border-b">Čas</th>
                          <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 border-b">Typ</th>
                          <th className="px-4 py-3 text-left text-sm font-semibold text-slate-700 border-b"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {terminy.map((termin, index) => (
                          <tr key={termin.id} className={index % 2 === 0 ? 'bg-white' : 'bg-slate-50/50'}>
                            <td className="px-4 py-3 text-sm font-bold text-teal-600 border-b">#{termin.id}</td>
                            <td className="px-4 py-3 text-sm text-slate-900 border-b">{termin.lekce1}</td>
                            <td className="px-4 py-3 text-sm text-slate-900 border-b">{termin.lekce2}</td>
                            <td className="px-4 py-3 text-sm text-slate-700 border-b">{termin.cas}</td>
                            <td className="px-4 py-3 border-b">
                              <span className={`inline-flex items-center px-2.5 py-1 rounded text-xs font-medium ${
                                termin.typ === 'ranní' 
                                  ? 'bg-amber-100 text-amber-700' 
                                  : 'bg-blue-100 text-blue-700'
                              }`}>
                                {termin.typ}
                              </span>
                            </td>
                            <td className="px-4 py-3 border-b">
                              <Link
                                to="/kontakt"
                                className="bg-teal-500 hover:bg-teal-600 text-white text-sm font-medium px-4 py-2 rounded-lg transition-colors inline-block"
                              >
                                Přihlásit se
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Info sekce */}
        <section className="py-20 bg-slate-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-2xl p-8 border border-slate-200">
              <h3 className="text-2xl font-bold text-slate-900 mb-6">
                Máte otázky k online školení?
              </h3>
              <div className="space-y-4 text-slate-600">
                <p>
                  <strong className="text-slate-900">Jak se přihlásit?</strong><br />
                  Vyberte si termín a klikněte na "Přihlásit se". Vyplňte kontaktní formulář a my se vám ozveme s dalšími informacemi.
                </p>
                <p>
                  <strong className="text-slate-900">Můžu se přihlásit jako jednotlivec?</strong><br />
                  Ano! Online termíny jsou určeny jak pro jednotlivé pedagogy, tak pro celé školy.
                </p>
                <p>
                  <strong className="text-slate-900">Je obsah stejný pro MŠ, ZŠ a SŠ?</strong><br />
                  Obsah přizpůsobujeme podle složení účastníků kurzu.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
